(function () {
    'use strict';

    /**
     * 
     * @param {string} selector - The selector for the carousel element. 
     * @param {Object} config - The configuration object for the carousel.
     * @param {HTMLElement} config.root - The root element to search for the carousel elements.
     * @param {string} config.containerSelector - The selector of the container element.
     * @param {string} config.jsSelector - The selector of the JavaScript class prefix for navigation elements.
     * @param {Object} config.swiperOptions - The Swiper options object. 
     */
    window.setupSwiper = function (selector, config) {
        const root = getComputedStyle(document.documentElement);
        const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
        const spaceBetween = parseFloat(root.getPropertyValue('--grid-column-spacer')) * rootFontSize;

        const scope = config && config.root ? config.root : document;
        const carousel = scope.querySelectorAll(selector);

        carousel.forEach((carouselEl) => {
            if (carouselEl.swiper) {
                carouselEl.swiper.destroy(true, true);
            }

            delete carouselEl.dataset.badgeBound;

            const container = carouselEl.closest(`${config.containerSelector}`);
            let carouselNav, prevEl, nextEl;

            if (container) {
                carouselNav = container.querySelector('.js-carousel-nav');
                prevEl = container.querySelector(`${config.jsSelector}-nav-prev`);
                nextEl = container.querySelector(`${config.jsSelector}-nav-next`);
            }

            const updateNavVisibility = () => {
                if (!carouselNav) return;

                const bothDisabled = prevEl.classList.contains('swiper-button-disabled')
                    && nextEl.classList.contains('swiper-button-disabled');

                carouselNav.classList.toggle('is-active', !bothDisabled);
                carouselNav.classList.toggle('is-disabled', bothDisabled);
            };

            new Swiper(carouselEl, {
                direction: 'horizontal',
                spaceBetween: spaceBetween,
                mobileFirst: true,
                grabCursor: true,
                speed: 500,
                navigation: {
                    prevEl,
                    nextEl,
                },
                on: {
                    init: updateNavVisibility,
                    resize: updateNavVisibility,
                    sliderMove: () => carouselEl.classList.add('is-dragging'),
                    touchEnd: () => carouselEl.classList.remove('is-dragging'),
                },
                ...config.swiperOptions,
            });
        });
    }
})();